import * as net from '../net';

const ContentDAO = {};

ContentDAO.getBlogPosts = () => net.get({url: 'https://cdn.contents.io/teams/euro-style/collections/blog-posts/items'})

ContentDAO.getBlogPost = (slug) => net.get({url: 'https://cdn.contents.io/teams/euro-style/collections/blog-posts/items/' + slug})

export default ContentDAO;
